<div class="skeleton-loader" [style.width]="width" [style.height]="height" [style.border-radius]="shape === 'circle' ? '50%' : borderRadius"></div> 